/**
 * Blackout wire shapes, split the way the API is: `SurveyRedaction*` is the stored overlay and the
 * masked projection every ordinary read carries, `SurveyBlackout*` is the staff editor's own
 * request/response pair. The dividing line is which string the offsets address — the ORIGINAL text
 * (editor only) or the MASKED one (everyone else).
 */
export var SurveyRedactionField;
(function (SurveyRedactionField) {
    SurveyRedactionField["TEXT_VALUE"] = "TEXT_VALUE";
    SurveyRedactionField["CUSTOM_TEXT"] = "CUSTOM_TEXT";
})(SurveyRedactionField || (SurveyRedactionField = {}));
